<template>
    <v-content>
        <v-row>
            <v-col class="title"> Список пользователей </v-col>
        </v-row>
        <v-expansion-panels multiple>
            <v-expansion-panel>
                <v-expansion-panel-header class="table-filters-header"
                >Показатели</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                    <v-col>
                        <v-row>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.name" label="Имя"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.second_name"
                                    label="Отчество"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.surname" label="Фамилия"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.sms_count_after_ban" label="Смс после бана"></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox color="info" v-model="showColumns.sms_count_before_ban" label="Смс до бана"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_source"
                                    label="utm_source"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_campaign"
                                    label="utm_campaign"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_content"
                                    label="utm_content"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_medium"
                                    label="utm_medium"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.utm_term"
                                    label="utm_term"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub1"
                                    label="aff_sub1"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub2"
                                    label="aff_sub2"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub3"
                                    label="aff_sub3"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.aff_sub5"
                                    label="aff_sub5"
                                ></v-checkbox>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.is_sms_blocked"
                                    label="is_sms_blocked"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.created_at"
                                    label="Дата регистрации"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.vkid"
                                    label="VK Id"
                                ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox
                                    color="info"
                                    v-model="showColumns.pxlid"
                                    label="FB Id"
                                ></v-checkbox>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                    </v-col>

                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="table-filters-header"
                >Фильтры</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                    <v-col>
                        <v-row>
                            <v-col>
                                <TimePicker
                                    :model.sync="filters.registerDate.from"
                                    label="Дата регистрации: от"
                                    :outlined="true"
                                    :dense="true"
                                ></TimePicker>
                            </v-col>
                            <v-col>
                                <TimePicker
                                    :model.sync="filters.registerDate.to"
                                    label="Дата регистрации: до"
                                    :outlined="true"
                                    :dense="true"
                                ></TimePicker>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-text-field label="ID" outlined dense hide-details v-model="filters.id">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field label="Email" outlined dense hide-details v-model="filters.email">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field label="Телефон" outlined dense hide-details v-model="filters.phone">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="utm_source"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.utm_source"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="utm_content"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.utm_content"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="utm_campaign"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.utm_campaign"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="utm_medium"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.utm_medium"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="utm_term"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.utm_term"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <MultiplySelect
                                    :model.sync="filters.offer_ids"
                                    :options="offers"
                                    field="name"
                                    value="id"
                                    :dense="true"
                                    placeholder="Сделки с оффером"
                                >
                                </MultiplySelect>
                            </v-col>
                            <v-col>
                                <MultiplySelect
                                    :model.sync="filters.excluded_offer_ids"
                                    :options="offers"
                                    field="name"
                                    value="id"
                                    :dense="true"
                                    placeholder="Сделки без офферов"
                                >
                                </MultiplySelect>
                            </v-col>
                            <v-col>
                                <MultiplySelect
                                    :model.sync="filters.statuses"
                                    :options="statuses"
                                    field="description"
                                    value="name"
                                    :dense="true"
                                    placeholder="Сделки с статусом"
                                >
                                </MultiplySelect>
                            </v-col>
                            <v-col>
                                <MultiplySelect
                                    :model.sync="filters.excluded_statuses"
                                    :options="statuses"
                                    field="description"
                                    value="name"
                                    :dense="true"
                                    placeholder="Сделки без статусов"
                                >
                                </MultiplySelect>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="aff_sub1"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.aff_sub1"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="aff_sub2"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.aff_sub2"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="aff_sub3"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.aff_sub3"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="aff_sub5"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.aff_sub5"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="VK Id"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.vkid"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    label="FB Id"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="filters.pxlid"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-select
                                    :items="isBlocked"
                                    label="is_sms_blocked"
                                    outlined
                                    dense
                                    item-text="name"
                                    item-value="value"
                                    v-model="filters.is_sms_blocked"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
            <v-col>
                <div class="title">Всего выбрано {{ tableData.total }}</div>
            </v-col>
            <v-col>
                <v-select
                    v-model="perPage"
                    @change="getUsers()"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    return-object
                    outlined
                    dense
                ></v-select>
            </v-col>
            <v-col>
                <v-btn @click="clearFilters()" color="info">Очистить фильтры</v-btn>
            </v-col>
            <v-col>
                <v-btn @click="getUsers()" color="primary">Применить</v-btn>
            </v-col>
            <v-col v-if="extendedColumns">
                <v-btn @click="deleteUsers()" color="primary">Удалить выбранных</v-btn>
            </v-col>
            <v-col v-if="extendedColumns">
                <v-btn @click="createCSV()" color="primary">Выгрузить CSV</v-btn>
            </v-col>
        </v-row>
        <b-table
            :data="tableData.results"
            :loading="loading"
            paginated
            backend-pagination
            :total="tableData.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            :checked-rows.sync="checkedRows"
            checkable
            :opened-detailed="defaultOpenedDetails"
            detailed
            detail-key="id"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            class="users-table"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" style="width: 50px;" numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="details" label="Подробности">
                    <v-btn outlined color="primary" x-small @click="details(props.row)">
                        Открыть
                    </v-btn>
                </b-table-column>

                <b-table-column field="email" label="Email" sortable>
                    <span :class="type(props.row.is_email_confirm)">
                        {{ props.row.email }}
                    </span>
                </b-table-column>

                <b-table-column field="phone" label="Телефон" sortable>
                    <span :class="type(props.row.is_phone_confirm)">
                        {{ props.row.phone }}
                    </span>
                </b-table-column>

                <b-table-column field="phone" label="Группы" sortable>
                    <div
                        v-if="props.row.groups && props.row.groups.length"
                        v-for="group in props.row.groups"
                    >
                        <span style="white-space: nowrap;">- {{ group.name }}</span>
                    </div>
                </b-table-column>

                <b-table-column field="name" label="Имя" :visible="showColumns.name" sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column
                    field="second_name"
                    label="Отчество"
                    :visible="showColumns.second_name"
                    sortable
                >
                    {{ props.row.second_name }}
                </b-table-column>

                <b-table-column
                    field="surname"
                    label="Фамилия"
                    :visible="showColumns.surname"
                    sortable
                >
                    {{ props.row.surname }}
                </b-table-column>

                <b-table-column
                    field="utm_campaign"
                    label="utm_campaign"
                    :visible="showColumns.utm_campaign"
                >
                    {{ props.row.utm_campaign }}
                </b-table-column>

                <b-table-column
                    field="created_at"
                    label="Дата регистрации"
                    :visible="showColumns.created_at"
                    sortable
                >
                    {{ props.row.created_at | isoToDateTime }}
                </b-table-column>

                <b-table-column
                    field="utm_content"
                    label="utm_content"
                    :visible="showColumns.utm_content"
                >
                    {{ props.row.utm_content }}
                </b-table-column>

                <b-table-column
                    field="utm_medium"
                    label="utm_medium"
                    :visible="showColumns.utm_medium"
                >
                    {{ props.row.utm_medium }}
                </b-table-column>

                <b-table-column field="utm_source" label="utm_source">
                    {{ props.row.utm_source }}
                </b-table-column>

                <b-table-column field="utm_term" label="utm_term" :visible="showColumns.utm_term">
                    {{ props.row.utm_term }}
                </b-table-column>

                <b-table-column field="aff_sub1" label="aff_sub1" :visible="showColumns.aff_sub1">
                    {{ props.row.aff_sub1 }}
                </b-table-column>

                <b-table-column field="aff_sub2" label="aff_sub2" :visible="showColumns.aff_sub2">
                    {{ props.row.aff_sub2 }}
                </b-table-column>

                <b-table-column field="aff_sub3" label="aff_sub3" :visible="showColumns.aff_sub3">
                    {{ props.row.aff_sub3 }}
                </b-table-column>

                <b-table-column field="aff_sub5" label="aff_sub5" :visible="showColumns.aff_sub5">
                    {{ props.row.aff_sub5 }}
                </b-table-column>

                <b-table-column field="aff_sub3" label="sms_before_ban" :visible="showColumns.sms_count_before_ban">
                    {{ props.row.sms_count_before_ban }}
                </b-table-column>

                <b-table-column field="aff_sub3" label="sms_after_ban" :visible="showColumns.sms_count_after_ban">
                    {{ props.row.sms_count_after_ban }}
                </b-table-column>

                <b-table-column field="is_sms_blocked" label="is_sms_blocked" :visible="showColumns.is_sms_blocked">
                    {{ props.row.is_sms_blocked }}
                </b-table-column>

                <b-table-column field="vkid" label="VK Id" :visible="showColumns.vkid">
                    {{ props.row.vkid }}
                </b-table-column>

                <b-table-column field="pxlid" label="FB Id" :visible="showColumns.pxlid">
                    {{ props.row.pxlid }}
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
                <b-table :data="props.row.utms" :columns="nestedColumns"></b-table>
            </template>
        </b-table>
        <confirmDeletionModal
            v-bind:checkedRows="checkedRows"
            v-bind:params="params"
        ></confirmDeletionModal>
        <confirmCSVModal></confirmCSVModal>
    </v-content>
</template>

<script>
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";
import PostbackStatuses from "@/app/admin/postbacks/shared/services/postbackStatuses";
import TimePicker from "@/app/shared/components/form-inputs/TimePicker";
import confirmDeletionModal from "@/app/admin/users/shared/modals/confirmDeletionModal";
import confirmCSVModal from "@/app/admin/users/shared/modals/confirmCSVModal";

export default {
    name: "UserTable",
    components: {
        MultiplySelect,
        TimePicker,
        confirmDeletionModal,
        confirmCSVModal,
    },
    props: ["extendedColumns", "canDelete"],
    data() {
        return {
            // data: [],
            // total: 0,
            panel: [1],
            loading: false,
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            defaultOpenedDetails: [1],
            statuses: PostbackStatuses.get(),
            nestedColumns: [
                {
                    field: "created_at",
                    label: "Дата создания",
                },
                {
                    field: "utm_source",
                    label: "utm_source",
                },
            ],
            isBlocked: [{
                name: 'Да', value: true,
            }, {
                name: 'Нет', value: false,
            }],
        };
    },
    created() {
        this.getUsers();
        this.$store.dispatch("GET_OFFERS");
    },
    computed: {
        showColumns() {
            return this.$store.getters.GET_SHOW_COLUMNS;
        },
        filters() {
            return this.$store.getters.GET_USERS_FILTERS;
        },
        offers() {
            return this.$store.getters.OFFERS;
        },
        requestFilters() {
            return this.$store.getters.GET_USERS_REQUEST_FILTERS;
        },
        params() {
            let params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                // filters: this.requestFilters,
                filters: JSON.parse(JSON.stringify(this.requestFilters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }

            return params;
        },
        tableData() {
            return this.$store.getters.GET_TABLE_DATA;
        },
        checkedRows: {
            get() {
                return this.$store.getters.GET_CHECKED_ROWS;
            },
            set(rows) {
                this.$store.dispatch("CHECKED_ROWS", rows);
            },
        },
    },
    methods: {
        getUsers() {
            this.loading = true;
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                // filters: this.requestFilters,
                filters: JSON.parse(JSON.stringify(this.requestFilters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.registerDate.from) {
                let some_date = new Date(params.filters.registerDate.from);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.from = some_date;
            }
            if (params.filters.registerDate.to) {
                let some_date = new Date(params.filters.registerDate.to);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.registerDate.to = some_date;
            }

            this.$store
                .dispatch("GET_USERS", params)
                .then((data) => {})
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteUsers() {
            if (this.checkedRows.length !== 0) {
                this.$store.dispatch("CONFIRM_DELETION_MODAL", true);
            }
        },
        createCSV() {
            this.$store.dispatch("CONFIRM_CSV_MODAL", true);
        },
        onPageChange(page) {
            this.page = page;
            this.getUsers();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getUsers();
        },
        // Style for email and phone
        type(verificated) {
            if (verificated) {
                return "verificated";
            }
            return "not_verificated";
        },
        clearFilters() {
            this.$store.dispatch("REFRESH_USER_FILTERS");
            this.getUsers();
        },
        details(user) {
            const route = this.$router.resolve({ path: `/admin/users/details/${user.id}` });
            window.open(route.href, "_blank");
        },
    },
    watch: {
        "tableData.results": {
            handler: function () {
                this.$emit(
                    "newdata",
                    this.tableData.results.map((x) => {
                        return {
                            name: x.phone,
                            uuid: x.uuid,
                        };
                    })
                );
            },
            deep: true,
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.verificated {
    color: #30a838;
}
.not_verificated {
    color: #e20000;
}
.users-table {
    overflow: auto;
    font-size: 12px;
}
</style>
